import { useState } from 'react';
import { api } from '../../api/client';
import { Modal, Field, label } from '../ui.jsx';
import { useConfirm, useToast } from '../feedback.jsx';
import { t } from '../../i18n/index.jsx';

export const SAL_STATUSES = ['planned', 'in_progress', 'submitted', 'approved', 'paid'];
export const blankSal = {
  fund_client_id: '', seq: 1, title: '', planned_date: '', planned_amount: '',
  status: 'planned', submitted_date: '', approved_date: '', paid_date: '', paid_amount: '', notes: '',
};

/** Create/edit a SAL milestone (Stato Avanzamento Lavori) under an enrollment. */
export default function SalForm({ initial, onClose, onSaved }) {
  const confirm = useConfirm();
  const toast = useToast();
  const isNew = !initial.id;
  const [form, setForm] = useState({ ...blankSal, ...initial });
  const [baseline] = useState(() => JSON.stringify({ ...blankSal, ...initial }));
  const [errors, setErrors] = useState({});
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  async function save() {
    setBusy(true); setErrors({});
    try {
      if (isNew) await api.post('/sal', form);
      else await api.put(`/sal/${initial.id}`, form);
      toast(isNew ? t('Milestone created') : t('Milestone saved'));
      onSaved();
    } catch (err) { setErrors(err.fields || { _: err.message }); }
    finally { setBusy(false); }
  }

  async function remove() {
    if (!(await confirm({ title: t('Delete milestone'), message: t('Delete this payment milestone?'), confirmLabel: t('Delete'), danger: true }))) return;
    await api.del(`/sal/${initial.id}`);
    toast(t('Milestone deleted'));
    onSaved();
  }

  return (
    <Modal title={isNew ? t('New payment milestone') : t('Edit payment milestone')} onClose={onClose}
      dirty={JSON.stringify(form) !== baseline}
      footer={
        <div className="modal-actions">
          {!isNew && <button className="btn danger ghost" onClick={remove}>{t('Delete')}</button>}
          <div className="spacer" />
          <button className="btn ghost" onClick={onClose}>{t('Cancel')}</button>
          <button className="btn primary" onClick={save} disabled={busy}>{busy ? t('Saving…') : t('Save')}</button>
        </div>
      }>
      {errors._ && <div className="alert error">{errors._}</div>}
      <div className="grid-2">
        <Field label={t('Milestone #')}><input type="number" min="1" value={form.seq ?? 1} onChange={set('seq')} /></Field>
        <Field label={t('Status')}><select value={form.status} onChange={set('status')}>{SAL_STATUSES.map((s) => <option key={s} value={s}>{label(s)}</option>)}</select></Field>
      </div>
      <Field label={t('Title')} error={errors.title}><input value={form.title} onChange={set('title')} placeholder={t('e.g. SAL 1 — 30% progress')} /></Field>

      <div className="grid-2">
        <Field label={t('Planned date')} error={errors.planned_date}><input type="date" value={form.planned_date || ''} onChange={set('planned_date')} /></Field>
        <Field label={t('Planned amount (€)')}><input type="number" step="0.01" value={form.planned_amount ?? ''} onChange={set('planned_amount')} /></Field>
      </div>
      <div className="grid-3">
        <Field label={t('Submitted')}><input type="date" value={form.submitted_date || ''} onChange={set('submitted_date')} /></Field>
        <Field label={t('Approved')}><input type="date" value={form.approved_date || ''} onChange={set('approved_date')} /></Field>
        <Field label={t('Paid')}><input type="date" value={form.paid_date || ''} onChange={set('paid_date')} /></Field>
      </div>
      <Field label={t('Paid amount (€)')}><input type="number" step="0.01" value={form.paid_amount ?? ''} onChange={set('paid_amount')} /></Field>
      <Field label={t('Notes')}><textarea rows={2} value={form.notes || ''} onChange={set('notes')} /></Field>
    </Modal>
  );
}
